import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import {
  BehaviorSubject,
  EMPTY,
  Observable,
  of,
  throwError,
  timer,
} from 'rxjs';
import { AuthService } from '../auth.service';
import {
  catchError,
  filter,
  finalize,
  switchMap,
  take,
  tap,
} from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable()
export class TokenHttpInterceptor implements HttpInterceptor {
  http_request_count = 0;
  constructor(
    private service: AuthService,
    private snackBar: MatSnackBar,
    private spinner: NgxSpinnerService
  ) {}
  private isRefreshing = false;
  private refreshTokenSubject = new BehaviorSubject<any>(null);
  private apiUrl = environment.api_endpoint;
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Count all http request to show spinner while http request is in progress
    this.http_request_count++;
    this.spinner.show();
    const authToken = this.service.getToken();
    let authRequest = request;
    if (authToken && request.url !== `${this.apiUrl}refresh-token`) {
      authRequest = request.clone({
        headers: request.headers.set(`Authorization`, authToken),
      });
    }
    return next.handle(authRequest).pipe(
      catchError((err: any) => {
        if (err.status === 403) {
          return this.handle403Error(request, next);
        } else return throwError(err);
      }),
      finalize(() => {
        if (this.http_request_count !== 0) this.http_request_count--;
        if (this.http_request_count <= 0) {
          this.spinner.hide();
        }
      })
    );
  }

  private handle403Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.service.refreshToken().pipe(
        switchMap((token: any) => {
          const jwt = token.headers.get('authorization')?.split(' ')[1];
          this.isRefreshing = false;
          this.refreshTokenSubject.next(jwt);

          const newRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${jwt}`),
          });
          return next.handle(newRequest);
        }),
        catchError((err: any) => {
          if (this.http_request_count !== 0) this.http_request_count--;
          if (this.http_request_count <= 0) {
            this.spinner.hide();
          }
          return throwError(err);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token != null),
        take(1),
        switchMap((jwt) => {
          const newRequest = request.clone({
            headers: request.headers.set('Authorization', `Bearer ${jwt}`),
          });
          return next.handle(newRequest);
        })
      );
    }
  }
}
